<div id="microbiologyResults" style="padding: 8px;">
    <div *ngIf="alphaMicResults.length > 0">
        <dx-tree-list
            [dataSource]="alphaMicResults"
            [dataStructure]="'tree'"
            [itemsExpr]="'tests'"
            [showRowLines]="true"
            [showBorders]="true"
            [hoverStateEnabled]="true"
            [highlightChanges]="true"
            [columnAutoWidth]="true"
            [allowColumnResizing]="true"
            height='100%'
            (onRowExpanding)="rowOperation = true"
            (onRowExpanded)="rowOperation = false"
            (onRowCollapsing)="rowOperation = true"
            (onRowCollapsed)="rowOperation = false"
            [columnHidingEnabled]="isPhoneOrTablet"
        >
            <dxo-filter-row [showOperationChooser]="true" [visible]="true"></dxo-filter-row>
            <dxo-scrolling [mode]="'standard'" [showScrollbar]="'true'"></dxo-scrolling>
            <dxi-column
                caption="Name"
                cellTemplate="nameTemplate"
                allowFiltering="true"
                [calculateFilterExpression]="calculateNameFilter" [hidingPriority]="isPhoneOrTablet ? 3 : -1"
            ></dxi-column>
            <dxi-column caption="Result" cellTemplate="resultsTemplate" allowFiltering="false" [hidingPriority]="isPhoneOrTablet ? 3 : -1"></dxi-column>
            <dxi-column dataField="flag" caption="Flag" allowFiltering="true" [hidingPriority]="isPhoneOrTablet ? 3 : -1"></dxi-column>
            <dxi-column caption="Reference Range" cellTemplate="referenceRangeTemplate" [hidingPriority]="isPhoneOrTablet ? 0 : -1"></dxi-column>

            <div *dxTemplate="let result of 'nameTemplate'">
                {{ result.data.name }}
                <span *ngIf="result.data?.resultReportComments">
                    <p *ngIf="result.data?.resultReportComments" [innerHtml]="transformYourHtml(result.data?.resultReportComments)" style="border: 0; padding: 20px; overflow-x: auto"></p>
                </span>
            </div>

            <div *dxTemplate="let result of 'resultsTemplate'">
                {{ result.data?.result }}
                <span *ngIf="result.data?.comment">
                    <p *ngIf="result.data?.comment" [innerHtml]="transformYourHtml(result.data.comment)" style="border: 0; padding: 20px; overflow-x: auto"></p>
                </span>
            </div>

            <div *dxTemplate="let result of 'referenceRangeTemplate'">
                {{ result.data?.referenceRange }}
                <span *ngIf="result.data?.clinicalRangeComment">
                    <p *ngIf="result.data?.clinicalRangeComment" [innerHtml]="transformYourHtml(result.data?.clinicalRangeComment)" style="border: 0; padding: 20px; overflow-x: auto"></p>
                </span>
            </div>
        </dx-tree-list>
    </div>

    <div fxLayout="column" style="margin-top: 8px; padding-left: 16px; padding-right: 16px;" fxLayoutAlign="space-between">
        <div *ngFor="let result of pureMicResults">
            <h4>{{ result?.name }}</h4>
            <div *ngIf="
                    result?.status !== 16 &&
                    result?.preliminaryResultComment !== null &&
                    result?.preliminaryResultComment !== ''
                " [innerHtml]="transformYourHtml(result?.preliminaryResultComment ?? '')" style="border: 0; padding: 20px; overflow-x: auto"></div>
            <div *ngIf="
                    result.resultReportComments !== null &&
                    result.resultReportComments !== ''
                " [innerHtml]="transformYourHtml(result?.resultReportComments ?? '')" style="border: 0; padding: 20px; overflow-x: auto"></div>


            <div fxLayout="row" fxLayoutAlign="start">
                <div fxLayout="column" fxLayoutAlign="space-between">
                    <span><strong>Status: </strong>{{ status(result?.status ?? 0, result?.preliminaryReleased ?? false) }}</span>
                    <span *ngIf="result?.sources !== null && result?.sources !== ''">
                        <strong>Source: </strong>{{ result?.sources }}</span
                    >
                    <span *ngIf="result?.collectionSite !== null && result?.collectionSite !== ''"
                        ><strong>Collection Site: </strong>{{ result?.collectionSite }}</span
                    >
                    <span *ngIf="formatDate(result?.collected) !== ''"
                        ><strong>Collected: </strong>{{ formatDate(result?.collected) }}</span
                    >
                </div>
            </div>

            <div *ngIf="result?.findings !== null && (result?.findings?.length ?? 0) > 0 && ((result?.organisms?.length ?? 0) === 0)"
                 style="margin-top: 8px; padding-left: 16px; padding-right: 16px;">
                <dx-list [items]="(result?.findings ?? [])" [noDataText]="''">
                    <div *dxTemplate="let item of 'item'">
                        <div fxLayout="row" fxLayoutAlign="space-between" style="border-bottom: 1px #d4d4d4 solid;">
                            <div>{{ item?.name }}</div>
                            <div>{{ item?.cultureQuantityName }}</div>
                        </div>
                    </div>
                </dx-list>
            </div>

            <div *ngIf="result?.organisms !== null && (result?.organisms?.length ?? 0) > 0">
                <div *ngFor="let organism of result?.organisms">
                  <br/>
                    <strong>{{ organism?.name }} {{ organism?.cultureQuantityName }}</strong>
                    <div *ngIf="organism?.comment !== null && organism?.comment !== ''" fxLayout="row">
                        <p [innerHtml]="transformYourHtml((organism?.comment ?? ''))" style="border: 0; padding: 5px; overflow-x: auto"></p>
                    </div>
                    <div *ngIf="organism?.organismComment !== null && organism?.organismComment !== ''" fxLayout="row">
                        <p [innerHtml]="transformYourHtml((organism?.organismComment ?? ''))" style="border: 0; padding: 5px; overflow-x: auto"></p>
                    </div>
                    <dx-list *ngIf="organism?.sensitivity && (organism?.sensitivity?.length ?? 0) > 0"
                             [items]="(organism?.sensitivity ?? [])" [noDataText]="''">
                        <div *dxTemplate="let item of 'item'" style="border-bottom: 1px #d4d4d4 solid;">
                            <div fxLayout="row" fxLayoutAlign="space-between">
                                <div style="min-width: 200px;">{{ item?.antibioticName }}</div>
                                <div style="min-width: 200px;">{{ item?.mic }}</div>
                                <div style="min-width: 200px;">{{ item?.microbiologyInterpretationType }}</div>
                            </div>
                            <div *ngIf="item?.comment" fxLayout="row">
                                <p [innerHtml]="transformYourHtml(item?.comment)" style="border: 0; padding: 20px; overflow-x: auto"></p>
                            </div>
                        </div>
                    </dx-list>
                </div>
            </div>
        </div>
    </div>
</div>
